var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCounter3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_199_1997)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 40,
    fill: "#FFBC1F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.428 56.4143L72.3523 52.7479C72.1076 52.6387 71.8166 52.6387 71.5718 52.7479L63.4961 56.4143C63.1456 56.5713 62.9141 56.9331 62.9141 57.3291C62.9141 57.7251 63.1456 58.087 63.4961 58.244L71.5718 61.9103C71.6975 61.9649 71.8298 61.9922 71.9621 61.9922C72.0943 61.9922 72.2266 61.9649 72.3523 61.9103L80.428 58.2508C80.7786 58.0938 81.0101 57.7319 81.0101 57.336C81.0101 56.94 80.7786 56.5781 80.428 56.4143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.9553 63.9996C71.5518 63.9996 71.1616 63.9177 70.7912 63.747L65.5 61.3438V62.2586C65.5 63.0711 65.9101 63.8358 66.5715 64.2522C68.4366 65.4197 70.196 66 71.9553 66C73.7146 66 75.4806 65.4129 77.3391 64.2522C78.0005 63.8358 78.4106 63.0711 78.4106 62.2586V61.3438L73.126 63.747C72.7556 63.9177 72.3588 63.9996 71.9553 63.9996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.626 47.3339C65.1843 47.3339 68.0813 44.3435 68.0813 40.6635C68.0813 36.9836 65.1843 34 61.626 34C58.0676 34 55.1641 36.9904 55.1641 40.6704C55.1641 44.3503 58.061 47.3339 61.626 47.3339Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3311 57.3356C60.3311 55.8813 61.1579 54.5636 62.4476 53.9765L69.9149 50.5764C69.1675 50.2009 68.3275 50.0029 67.4346 50.0029H55.8137C52.6125 50.0029 50 52.6929 50 56.0042V61.3364C50 61.7051 50.2844 62.0055 50.6482 62.0055H62.9172V60.8995L62.4542 60.6878C61.1579 60.0938 60.3311 58.7761 60.3311 57.3356Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_199_1997",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.698039 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_199_1997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_199_1997",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter3);
export default __webpack_public_path__ + "static/media/counter-3.3e1115e8d5358b59411758099e4ccfb8.svg";
export { ForwardRef as ReactComponent };